import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject, provideEnvironmentInitializer, type EnvironmentProviders } from '@angular/core';

/** Cells and clamp utilities that cut their text with an ellipsis (see the list-table rules in styles/_wn-ui.scss). */
const TRUNCATING = 'table[class*="__table"] tbody td, .wn-cell-clamp, [class*="__clamp"]';

/**
 * WN-946: a cell clamped to one line must still let the user read the whole value. On hover, a truncating element
 * whose text overflows (and has no title of its own) gets its full text as `title`. Answers whether a title was set.
 */
export function applyTruncationTitle(target: EventTarget | null): boolean {
  const el = target instanceof Element ? target.closest<HTMLElement>(TRUNCATING) : null;
  if (!el || el.hasAttribute('title') || el.scrollWidth <= el.clientWidth) {
    return false;
  }
  const text = el.textContent?.replace(/\s+/g, ' ').trim();
  if (!text) {
    return false;
  }
  el.setAttribute('title', text);
  return true;
}

/** One delegated listener for the whole app, so no table has to opt in. */
export function provideTruncationTooltips(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    if (!isPlatformBrowser(inject(PLATFORM_ID))) {
      return;
    }
    inject(DOCUMENT).addEventListener('mouseover', (event) => applyTruncationTitle(event.target), { passive: true });
  });
}
